<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Mancata Dichiarazione
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="dichiara" v-bind="attrs" v-on="on">
            <v-icon color="success" large> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Dichiara</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" v-bind="attrs" v-on="on">
            <v-icon color="error" large> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-container>
        <v-row align="center" justify="center">
          <v-col class="my-0 py-0" cols="6">
            <span style="font-size: 18px">Progressivo scatole raggiunto:</span>
          </v-col>
          <v-col class="my-0 py-0" cols="6">
            <span style="font-size: 18px">Pezzi per scatola:</span>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col class="my-0 py-0" cols="6">
            <v-text-field
              class="centered-input"
              style="
                display: inline-block;
                font-size: 20px;
                font-weight: bold;
                line-height: 25px;
                padding: 0px;
                min-width: 150px;
              "
              type="number"
              v-model.number="progressivo_scatole"
            />
          </v-col>
          <v-col class="my-0 py-0" cols="6">
            <span style="font-size: 18px">
              <b>{{ pz_per_scatola }}</b>
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Overlay di caricamento -->
    <!-- <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "FormMancataDichiarazione",
  components: { SnackbarQV },
  props: {
    // work_order_sel: { type: Object, default: () => {} },
    pz_per_scatola: { type: Number, default: null },
  },
  data() {
    return {
      // Variabili d'appoggio
      progressivo_scatole: 0,
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
      this.resetProperties();
    },
    dichiara() {
      this.$emit("dichiarazione_avvenuta", this.progressivo_scatole);
    },
    resetProperties() {
      this.progressivo_scatole = 0;
      this.pz_scatole = 25;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>